<template>
  <div class="content">
    <div class="wraper">
      <img class="t-img" :src="img" />
      <div class="content-wrap-d" v-if="jobItem">
        <div class="job-head">
          <div class="head-content">
            <div class="job-title">{{jobItem.position}}</div>
            <div class="base-info" v-html="jobItem.baseHtml"></div>
          </div>
        </div>
        <div class="job-body">
          <div class="detail-info" v-html="jobItem.detailHtml"></div>
        </div>
      </div>
    </div>
    <div class="job-bottom" v-if="jobItem">
      <div class="job-btn" @click="applyJob(jobItem.position)">申请职位</div>
    </div>
    <NetTest
      v-if="show"
      :url="netUrl"
      :step="step"
      :jobs="jobList"
      :currentPosition="currentPosition"
      @closeDialog="closeDialog"
    ></NetTest>
  </div>
</template>

<script>
import NetTest from "./NetTest";
export default {
  components: {
    NetTest,
  },
  data() {
    return {
      img: `${process.env.BASE_URL}ImgFiles/top-hyjr_04.jpg`,
      show: false,
      step: 0,
      netUrl: "",
      currentPosition: "",
    };
  },
  computed: {
    jobList() {
      return this.$store.state.jobList;
    },
    detaildid() {
      return this.$store.state.detaildid;
    },
    jobItem() {
      let jobitem = this.jobList[0];
      this.jobList.forEach((item, index) => {
        if (item.id == this.detaildid) {
          jobitem = item;
        }
      });
      return jobitem;
    },
  },
  methods: {
    applyJob(position) {
      this.currentPosition = position;
      this.$http.post("/User/IsLogin").then((res) => {
        if (res.status != 200 || !res.data) return;
        let isLogin = res.data;
        if (isLogin.status) {
          this.netUrl = isLogin.data.url;
          if (isLogin.data.status == 1) {
            this.showDialog(2);
          } else if (isLogin.data.status == 0) {
            // this.currentPosition = position;
            this.showDialog(1);
          }
        } else {
          // 未登录
          this.showDialog(0);
        }
      });
    },
    closeDialog() {
      this.show = false;
    },
    showDialog(step) {
      this.step = step;
      this.show = true;
    },
  },
  watch: {
    $route(to, from) {
      // 在该页面点击后退按钮，关闭弹框
      if (from.name == 'JobDetail') {
        this.closeDialog();
      }
    },
  }
};
</script>

<style scoped>
.content {
  top: 0;
  position: absolute;
  bottom: 0;
  overflow-y: auto;
  left: 0;
  right: 0;
  z-index: 12;
  background-color: rgb(247, 247, 247);
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.content-wrap-d {
  padding: 0.5rem 0.3386rem 2.6933rem 0.3386rem;
}
.job-head {
  padding: 0.2116rem;
  border-bottom: 1px rgb(225, 225, 225) solid;
  display: table;
  width: 100%;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
}
.head-content {
  display: table-cell;
  vertical-align: middle;
  height: 2.79rem;
}
.job-title {
  font-size: 0.62rem;
  color: rgb(59, 59, 59);
  font-weight: bold;
  margin-bottom: 0.2116rem;
}
.base-info {
  font-size: 0.58rem;
  color: rgb(103, 103, 103);
  line-height: 1rem;
}
.job-body {
  padding: 0.2116rem;
  color: rgb(103, 103, 103);
  font-size: 0.58rem;
}
.detail-row {
  margin-bottom: 0.3386rem;
}
.job-bottom {
  width: 100%;
  padding: 0.5rem 0;
  position: fixed;
  bottom: 0;
  background-color: #fff;
  right: 0;
  left: 0;
}
.job-btn {
  background-color: rgb(243, 152, 1);
  width: 4.5rem;
  line-height: 1.4rem;
  border-radius: 0.7rem;
  color: #fff;
  font-size: 0.593rem;
  margin: 0 auto;
  text-align: center;
}
</style>